import type { RootState } from 'types'

const informationList = (state: RootState) => state.information.information
const informationTopList = (state: RootState) => state.information.informationTop

export const InformationSelectors = {
  informationList,
  informationTopList,
}
